import {
  CvssSourceCategory,
  type CvssAssessment,
  type VulnPolicyFinding,
} from '../applications.models';

type FindingVulnerability = VulnPolicyFinding['details']['vulnerability'];

/**
 * Resolves the CVSS assessment to surface for a policy finding, tagging it with
 * the source category that drives the SeverityLabel badge. Vendor CVSS takes
 * precedence over NVD. Prefers the category Platform provides on the assessment,
 * deriving one (Other for vendor, NVD for the NVD feed) only when it is absent.
 */
export const getFindingCvssAssessment = (
  vulnerability: FindingVulnerability,
): CvssAssessment | null => {
  const { vendorCvss, nvdCvss } = vulnerability;
  if (vendorCvss) {
    return {
      ...vendorCvss,
      category: vendorCvss.category ?? CvssSourceCategory.Other,
    };
  }
  if (nvdCvss) {
    return { ...nvdCvss, category: nvdCvss.category ?? CvssSourceCategory.Nvd };
  }
  return null;
};
